module.exports = __webpack_public_path__ + "img/arrow-right.e886de27.svg";